import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en/common.json";
import zhTW from "./locales/zh-TW/common.json";
import ja from "./locales/ja/common.json";

export const supportedLanguages = ["en", "zh", "ja"] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

const languageMap: Record<string, string> = { en: "en", zh: "zh-TW", ja: "ja" };

export function getI18nLang(urlLang?: string): string {
  if (urlLang && urlLang in languageMap) return languageMap[urlLang];
  return "en";
}

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, "zh-TW": { translation: zhTW }, ja: { translation: ja } },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
